export const toggleTheme = () => {
    const theme = getTheme();
    localStorage.setItem("theme", theme === "dark" ? "light" : "dark");
}

export const getTheme = () => {
    return localStorage.getItem("theme") || "light";
}

export const themeDark = () => {
    return getTheme() === "dark"; 
}